import { render, staticRenderFns } from "./CountersView.vue?vue&type=template&id=525dfc55&scoped=true&"
import script from "./CountersView.vue?vue&type=script&lang=js&"
export * from "./CountersView.vue?vue&type=script&lang=js&"
import style0 from "./CountersView.vue?vue&type=style&index=0&id=525dfc55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525dfc55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
